import { render, staticRenderFns } from "./organizeTree.vue?vue&type=template&id=20281a1e&scoped=true"
import script from "./organizeTree.vue?vue&type=script&lang=js"
export * from "./organizeTree.vue?vue&type=script&lang=js"
import style0 from "./organizeTree.vue?vue&type=style&index=0&id=20281a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20281a1e",
  null
  
)

export default component.exports